export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/feedmyapp-f96b523d4cf328ed65911385db02cba6.png";